import React, { useEffect } from "react";
import Cookies from "universal-cookie";
import "./App.css";
import constants from "./constants/constants";
import { getToken } from "./constants/util";
import Store from "./localStorage/Store";
import Router from "./Router";
import DefaultWindow from "./components/DefaultWindow";
import { colors } from "./imports";
import Maintenance from "./pages/maintenance/Maintenance";
import { SetContextLink } from "@apollo/client/link/context";

import {
  ApolloClient,
  CombinedGraphQLErrors,
  HttpLink,
  InMemoryCache,
  ApolloLink,
  Observable,
} from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import { ErrorLink } from "@apollo/client/link/error";

const cookies = new Cookies();

const errorLink = new ErrorLink(({ error, operation, forward }) => {
  if (CombinedGraphQLErrors.is(error)) {
    for (let err of error.errors) {
      switch (err.message) {
        case "Internal server error":
          console.error(err);
          return new Observable((observer) => {
            refreshToken()
              .then((authToken) => {
                if (authToken) {
                  const oldHeaders = operation.getContext().headers;
                  cookies.set("AuthToken", authToken, { path: "/" });
                  operation.setContext({
                    headers: {
                      ...oldHeaders,
                      authorization: `Bearer ${authToken}`,
                    },
                  });

                  // retry the request, returning the new observable
                  const subscriber = {
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                  };
                  forward(operation).subscribe(subscriber);
                } else {
                  observer.error(new Error("Failed to refresh token"));
                }
              })
              .catch((error) => {
                // Handle token refresh errors e.g clear stored tokens, redirect to login
                cookies.remove("AuthToken", { path: "/" });
                cookies.remove("RefreshToken", { path: "/" });
                window.location.href = "./login";
                observer.error(error);
              });
          });

        default:
          return;
      }
    }
  }
});

const httpLink = new HttpLink({ uri: constants.backendUrl });
const authLink = new SetContextLink(async (req, { headers }) => {
  const token = await getToken();
  return {
    ...headers,
    headers: {
      authorization: token ? `Bearer ${token}` : null,
    },
  };
});
const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});

const RefreshTokenMutation = `
mutation RefreshJWTAuthToken( $input: String! ){
    refreshJwtAuthToken( input:{jwtRefreshToken: $input, clientMutationId: "RegisterUser"} ) {
      authToken
    }
  }
`;

async function refreshToken() {
  const token = await cookies.get("RefreshToken");
  return fetch(constants.backendUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: RefreshTokenMutation,
      variables: {
        input: token,
      },
    }),
  })
    .then((r) => r.json())
    .then((data) => {
      return data.data.refreshJwtAuthToken.authToken;
    });
}

const maintenance = false;

function App() {
  return (
    <ApolloProvider client={client}>
      <Store>
        {maintenance ? (
          <DefaultWindow
            showHeader={false}
            footerFontColor={colors.SolidWhiteBackground}
            background={colors.Cararra}
            exact
            path=""
          >
            <Maintenance />
          </DefaultWindow>
        ) : (
          <Router />
        )}
      </Store>
    </ApolloProvider>
  );
}

export default App;
